import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const Partners = () => {
  const { t } = useTranslation();

  const partners = [
    {
      name: 'CIDE Consulting',
      logo: '/images/partners/cide-consulting.jpg',
      url: 'https://cideconsulting.com/'
    },
    {
      name: 'KURSA',
      logo: '/images/partners/kursa-logo-v2.png',
      url: 'https://getkursa.space/'
    },
    {
      name: 'PrimeCorn',
      logo: '/images/partners/primcorn-logo-jpg.jpg',
      url: 'https://primecorn.net/'
    },
    {
      name: 'TchopNjoh',
      logo: '/images/partners/tchop-njoh (2).jpg',
      url: 'https://tchopnjoh.com/'
    },
    {
      name: 'Shopikat',
      logo: '/images/partners/shopikat-fav-icon.png',
      url: 'https://shopikat.com/'
    },
    {
      name: 'Pan African Savings & Loans',
      logo: '/images/partners/pasl-logo.png',
      url: 'https://panafricansl-cameroun.com/'
    },
    {
      name: 'Services Tech Sarl',
      logo: '/images/partners/servicestech-logo.png',
      url: 'https://servicestech.net/'
    },
    {
      name: 'Royal Express Travel',
      logo: '/images/partners/royal-express-travel-logo.png',
      url: 'https://www.royalexpresstravel.com/'
    },
    {
      name: 'Global Freightage Services',
      logo: '/images/partners/global-freightage-logo.png',
      url: 'https://www.globalfreightageservices.com/'
    },
    {
      name: 'Netrac Sarl',
      logo: '/images/partners/netrac-logo.png',
      url: 'https://www.netracsarl.com/'
    },
    {
      name: 'CFPCSL',
      logo: '/images/partners/cfpcsl-logo.png',
      url: 'https://cfpcsl.com/'
    },
    {
      name: 'Chez Fadi',
      logo: '/images/partners/chez-fadi-logo.png',
      url: 'https://chez-fadi.com/'
    },
    {
      name: 'Eunice KM',
      logo: '/images/partners/eunicekm-logo.jpg',
      url: 'https://eunicekm.com/'
    },
    {
      name: 'RMS Entreprise',
      logo: '/images/partners/rms-logo.png',
      url: 'https://rms-entreprise.com/'
    },
    {
      name: 'SCPT2C',
      logo: '/images/partners/scpt2c-logo.png',
      url: 'https://scpt2c.cm/'
    },
    {
      name: 'Olkoo',
      logo: '/images/partners/olkoo-logo.svg',
      url: 'https://olkoo.com/'
    },
    {
      name: 'Jobber 237',
      logo: '/images/partners/jobber237-logo.svg',
      width: 100,
      height: 100,
      url: 'https://jobber237.app/'
    },
    {
      name: 'Harmocare',
      logo: '/images/partners/harmocare-logo.png',
      width: 519,
      height: 497,
      url: 'https://harmocares.com/'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 w-1/2 h-1/2 bg-csl-green/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-10 sm:mb-14 animate-slide-up">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            <Trans i18nKey="partners.title">
              They <span className="text-csl-green">Trust Us</span>
            </Trans>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            {t('partners.description')}
          </p>
        </div>

        <Swiper
          modules={[A11y, Autoplay, Pagination]}
          spaceBetween={16}
          slidesPerView={1.4}
          centeredSlides={false}
          loop={true}
          autoplay={{ delay: 2500, disableOnInteraction: false, pauseOnMouseEnter: true }}
          pagination={{ clickable: true }}
          breakpoints={{
            640: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 24
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 32
            }
          }}
          className="pb-12"
        >
          {partners.map((partner) => (
            <SwiperSlide key={partner.name} className="h-auto">
              <a
                href={partner.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 p-5 sm:p-6 min-h-[120px] flex items-center justify-center hover:-translate-y-1 h-full"
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  width={partner.width}
                  height={partner.height}
                  loading="lazy"
                  decoding="async"
                  className="max-h-16 sm:max-h-20 max-w-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Partners;
